<div
  class="search"
  data-testid="topbar-search"
  [class.open]="isOpen()"
>
  <div class="field">
    <!-- Pesquisar -->
    <input
      type="text"
      data-testid="topbar-search-input"
      [placeholder]="translateService.getTranslation('OTIMUS3583')"
      [value]="query()"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (keydown)="onKeydown($event)"
    />
    <span class="material-symbols-outlined search-icon">search</span>
  </div>

  @if (isOpen()) {
    <div
      class="results"
      role="listbox"
      data-testid="topbar-search-results"
    >
      @if (loading()) {
        <!-- Buscando… -->
        <div class="empty">{{ translateService.getTranslation('OTIMUS4419') }}</div>
      } @else if (hasResults()) {
        @if (menus().length > 0) {
          <!-- Menus -->
          <oc-dropdown-menu-label data-testid="topbar-search-menus-label">
            {{ translateService.getTranslation('OTIMUS4420') }}
          </oc-dropdown-menu-label>
          @for (leaf of menus(); track leaf.id) {
            <oc-dropdown-menu-item
              data-testid="topbar-search-menu-result"
              [attr.data-result-label]="leaf.label"
              [routerLink]="leaf.route"
              queryParamsHandling="preserve"
              (click)="clear()"
            >
              <span class="result-label">{{ leaf.label }}</span>
            </oc-dropdown-menu-item>
          }
        }

        @if (menus().length > 0 && users().length > 0) {
          <oc-divider />
        }

        @if (users().length > 0) {
          <!-- Usuários -->
          <oc-dropdown-menu-label data-testid="topbar-search-users-label">
            {{ translateService.getTranslation('OTIMUS4421') }}
          </oc-dropdown-menu-label>
          @for (u of users(); track u.userId) {
            <oc-dropdown-menu-item
              data-testid="topbar-search-user-result"
              [attr.data-result-label]="u.personName || u.name"
              (click)="selectUser(u)"
            >
              <app-profile-pic
                class="result-profile-pic"
                [name]="u.personName || u.name"
                [imageUrl]="u.profilePicUrl"
              />
              <span class="result-label">
                {{ u.personName || u.name }}
              </span>
            </oc-dropdown-menu-item>
          }
        }
      } @else {
        <!-- Nenhum resultado para "{{ query() }}" -->
        <div
          class="empty"
          data-testid="topbar-search-empty"
        >
          {{ translateService.getTranslation('OTIMUS4427', { query: query() }) }}
        </div>
      }
    </div>
  }
</div>
